<template>
  <div>
    <!-- Navigation -->
    <navigation
      @prev="$emit('prev')"
      @next="$emit('next')"
      :activeStepIndex="activeStepIndex"
      :$v="$v"
      :processing-api="processingApi"
    />

    <!-- Form -->
    <section>
      <!-- Gender Input -->
      <div class="form-group">
        <label id="gender" :class="survey.id == 552 ? 'color-avai' : 'black'" class="title-bold" for="nome">{{$t('gender_identity')}}</label>
        <div class="error mt-n2" v-if="$v.profile.Gender.$error">
          <span class="error" v-if="!$v.profile.Gender.required">{{ $t('gender') + $t('is_required') }}</span>
        </div>
      </div>

      <div v-if="profile.Gender !== ''">
        <input @click="checkedInput()" type="checkbox" class="checkboxOption" checked/>
        <label class="ml-2 mb-3 fontCheckbox"> {{ getText }} </label>
      </div>

      <div class="group-gender">
        <button v-if="profile.Gender !== 'M'" @click="profile.Gender = 'M'" class="gender-options" id="masculino" :disabled="processingApi" @blur="$v.profile.Gender.$touch()">
          {{ $t('masculine') }}
        </button>
        <button v-if="profile.Gender !== 'F'" @click="profile.Gender = 'F'" class="gender-options" id="feminino" :disabled="processingApi">
          {{ $t('feminine') }}
        </button>
        <button v-if="profile.Gender !== 'NB'" @click="profile.Gender = 'NB'" class="gender-options" id="nb" :disabled="processingApi">
          {{ $t('non_binary') }}
        </button>
        <button v-if="profile.Gender !== 'N'" @click="profile.Gender = 'N'" class="gender-options" id="n" :disabled="processingApi">
          {{ genderType !== 2 ? $t('other') : $t('prefer_not_inform') }}
        </button>
      </div>


      <!-- Birth Date Input -->
      <div class="form-group">
        <label :class="survey.id == 552 ? 'color-avai' : 'black'" class="title-bold" for="nome">{{ $t('birth_date_field') }}</label>
        <div class="error mt-n2" v-if="$v.profile.Birthdate.$error">
          <span class="error " v-if="!$v.profile.Birthdate.required">{{ $t('birth_date') + $t('is_required_f') }}</span>
          <span class="error " v-else-if="!$v.profile.Birthdate.validBirth">{{ $t('birth_date') + $t('invalid_f') }}</span>
        </div>
        <input
          v-model="profile.Birthdate"
          class="form-control"
          placeholder="dd/mm/aaaa"
          v-mask="'##/##/####'"
          :disabled="processingApi"
          @keyup.enter="goToNextStep"
          @blur="$v.profile.Birthdate.$touch()"
        />
      </div>
    </section>

    <!-- Button -->
    <section class="row">
      <div class="col-12 mt-5 mx-auto col-md-6">
        <button
          :style="
            style.surveyBtnColor
              ? { backgroundColor: style.surveyBtnColor }
              : { backgroundColor: style.homeBtnColor }
          "
          type="submit"
          class="w-100 btn btn-primary btn-block my-3"
          @click="goToNextStep"
          :disabled="$v.$invalid"
        >
          {{ $t('advance') }}
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            v-if="processingApi"
          ></span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import Navigation from "@/components/registration/components/Navigation";

/* Helpers */
import { mask } from "vue-the-mask";

const validBirth = (dateStr) => {
  if (!dateStr || !dateStr.length) {
    return false
  }
  const s = dateStr.split('/')
  if (s[2] < 1900) {
    return false
  } else {
    const d = new Date(+s[2], s[1] - 1, +s[0])
    if (Object.prototype.toString.call(d) === '[object Date]') {
      if (!isNaN(d.getTime()) && d <= Date.now() && d.getDate() === Number(s[0]) && d.getMonth() === Number(s[1]) - 1) {
        return true
      } else {
        return false
      }
    }
  }
}

export default {
  name: "GenderAndBirthDate",
  components: {Navigation},
  data() {
    return {
      key: 0
    };
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    processingApi: {
      type: Boolean,
      required: true
    },
    activeStepIndex: {
      type: Number,
      required: true
    }
  },
  validations: {
    profile: {
      Gender: {
        required
      },
      Birthdate: {
        required,
        validBirth
      }
    }
  },
  computed: {
    style() {
      return this.$store.state.template.style;
    },
    survey() {
      return this.$store.state.template.survey;
    },
    genderType() {
      if (this.$store.state.template.registration.genderType) {
        return this.$store.state.template.registration.genderType
      }
      return 0
    },
    getText(){
      if (this.profile.Gender === 'M')
        return "Masculino"
      if (this.profile.Gender === 'F')
        return "Feminino"
      if (this.profile.Gender === 'NB'){
        return "Não-Binário"
      }
      if (this.profile.Gender === 'N' && this.genderType !== 2)
        return "Outro"
      else if(this.profile.Gender === 'N')
        return "Prefiro não informar"
    },
  },
  directives: {
    mask
  },
  mounted() {
    if (this.activeStepIndex !== 0) this.focusOn('gender')
  },
  methods: {
    focusOn(el) {
      document.getElementById(el).focus();
    },
    goToNextStep() {
      if (!this.$v.$invalid) {
        this.$emit('next')
      }

    },
    checkedInput(){
      this.profile.Gender = '';
    }
  }
};
</script>

<style scoped>
.gender-options{
  height: 50px;
  margin-bottom: 7px;
  border-radius: 10px;
  outline: none;
  background: white;
  border: 1px solid var(--btn-color);
}

.gender-options:hover{
    color: var(--btn-text-color);
}

.color-avai{
  color: #123654 !important;
}

.group-gender{
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.checkboxOption {
  transform: scale(1.6);
}

.checkboxOption:checked {
  accent-color: var(--btn-color) !important;
}

.fontCheckbox{
  font-size: 1.1rem;
}
</style>
